module.exports = __webpack_public_path__ + "media/images/icons/filled/video-camera-5374a9e181d42c709acca19b43d7937e.svg";